import { Box, Typography, Button, Paper, TableContainer, Table, TableHead, TableCell, useTheme, TableRow, TableBody, Tooltip } from '@mui/material'
import React, { useEffect } from 'react'
import ReactHtmlTableToExcel from 'react-html-table-to-excel'
import { Item } from '../../../common/snippets'
import { useState } from 'react'
import * as sx from '../../../common/stylesInline/report_daily_branch'
import autoTable from 'jspdf-autotable'
import jsPDF from 'jspdf'
import moment from 'moment'
import { callAddFontRobotoBold } from '../../../common/font/Roboto-bold'
import { callAddFontRobotoMedium } from '../../../common/font/Roboto-Medium-normal'
import BranchReceiveExcel from './excelTable/BranchReceiveExcel'
import { focusElemnt, navigation3, getStaOperatorHamaliLabel, isStaCompany } from '../../../common/helper'
import * as id from '../reportId'
import * as mdt from '../../../common/modaltypes'
import AppsIcon from '@mui/icons-material/Apps'
import { BranchTransRecExcelHeader, BranchTransRecExcelHeaderForBoth, BranchTransRecExcelHeaderFormattedLRNO, BranchTransRecExcelHeaderForRemoveGST, calculateDynamicFormatLandscape, calculateDynamicFormatPortrait, calculateTotalTableWidth, getBranchTransRecExcelHeader } from './excelTable/BranchReceiveConstant'
import { generateDynamicColumnStyles } from '../../../common/helper'
import { RAJESH_TRANSPORT } from '../../../../helper/companyIdhardcode'
const BranchReceive = (props) => {
    const {loginCountryId, updateModal, loginData, filterData, tableData, updateLoader, disableExcel, columnSummaryDefs = [], selectedFields, matchFields, isPdfLoading, setIsPdfLoading,UseFormattedLRinReports } = props
    const theme = useTheme()
    const { tableHeaderColor } = theme
    const [state, setState] = useState({
        generatePDF: false,
        load: false,
    })
    const [reportData, setReportData] = useState([])
    const currentDateTime = moment(window.getTime ? window.getTime() : new Date()).format('DD-MMM-YYYY HH:mm');
    useEffect(() => {
        if (tableData.length > 0) {
            const data = formatData(tableData)
            setReportData(data)
            updateLoader(false)
        } else {
            setReportData([{ isNoData: true, caption: 'No Records', colSpan: 17 }])
        }
    }, [tableData])
    const formatData = (data) => {
        const groupedData = data.reduce((result, item) => {
            const key = `${item.PaymentType}`
            if (!result[key]) {
                result[key] = []
            } result[key].push(item)
            return result
        }, {})
        let newData = [{
            isPrintHeading: true,
            caption: "Branch Transfer Received Report", colSpan: 17, align: 'left'
        }]
        let grandTotalRow = { Units: 0, Freight: 0, CartageAmount: 0, HamaliCharge: 0, OperatorHamaliChg: 0, OtherCharges: 0, Valuation: 0, BookingGST: 0, NetAmount: 0 }

        Object.keys(groupedData).map((val) => {
            let detailsData = []
            let totalRow = { Units: 0, Freight: 0, CartageAmount: 0, HamaliCharge: 0, OperatorHamaliChg: 0, OtherCharges: 0, Valuation: 0, BookingGST: 0, NetAmount: 0 }
            let headingRow = { isHeaderRow: true, sno: "S/N", LRNO: "LR No\nMan.LR No", ChallanNo: 'Challan\nNo', ReceiptDate: "Rcvr.Date\nRcvr.Time", Sender: "Sndr. Name\nSndr. No.", SenderGSTN: 'Sndr. GSTIN\nSndr. EmailID.', RecName: "Rcvr. Name\nRcvr. Name", ReceiverGSTN: 'Rcvr. GSTIN\nRcvr. EmailID', ItemDetails: "Item\nDetails", Units: 'Item\nUnits', Freight: 'Frt\nChrg', CartageAmount: 'Cart.\nChrg.', HamaliCharge: 'Ham.\nChrg.', ...(isStaCompany(loginData?.intCompanyID) ? { OperatorHamaliChg: getStaOperatorHamaliLabel(true) } : {}), OtherCharges: 'Oth.\nChrg.', Valuation: loginCountryId===2?'Insu.\nChrg.':'Val.\nChrg.', BookingGST: 'Bkg.\nGST', NetAmount: 'Net.\nAmt.' };
            if (loginData?.intCompanyID === RAJESH_TRANSPORT) {
                headingRow.Remarks = 'Remarks';
            }
            if (UseFormattedLRinReports === 2) {
                headingRow.LRNO = "Formatted LRNO\nMan.LR No"; // Change LRNO heading
            } else if (UseFormattedLRinReports === 3) {
                headingRow.FormattedLRNO = "Formatted\nLRNO"; // Add new heading after LRNO
            }
            let subHeading = {
                isSubHeadingRow: true, isSubHeadingData: [
                    { caption: "Payment Type:", value: val, colSpan: 5, align: 'left' },
                    { caption: "Transfer From Branch:", value: filterData.fromBranchName, colSpan: 6, align: 'center' },
                    { caption: "Transfer To Branch:", value: filterData.toBranchName, colSpan: 6, align: 'right' },
                ]
            };
            groupedData[val]?.map((val, index) => {
                detailsData.push({ isRowData: true, ...val, ReceiptDate: moment(new Date(val.ReceiptDate)).format("DD-MMM-YY"), ReceiptTime: moment(new Date(val.ReceiptDate)).format("HH:mm") })
                totalRow = {
                    Units: totalRow.Units + Number(val.Units),
                    Freight: totalRow.Freight + Number(val.Freight),
                    CartageAmount: totalRow.CartageAmount + Number(val.CartageAmount),
                    HamaliCharge: totalRow.HamaliCharge + Number(val.HamaliCharge),
                    OperatorHamaliChg: totalRow.OperatorHamaliChg + Number(val.OperatorHamaliChg || 0),
                    OtherCharges: totalRow.OtherCharges + Number(val.OtherCharges),
                    Valuation: totalRow.Valuation + Number(val.Valuation),
                    BookingGST: totalRow.BookingGST + Number(val.BookingGST),
                    NetAmount: totalRow.NetAmount + Number(val.NetAmount)
                }
            });
            grandTotalRow = {
                Units: grandTotalRow.Units + totalRow.Units,
                Freight: grandTotalRow.Freight + totalRow.Freight,
                CartageAmount: grandTotalRow.CartageAmount + totalRow.CartageAmount,
                HamaliCharge: grandTotalRow.HamaliCharge + totalRow.HamaliCharge,
                OperatorHamaliChg: grandTotalRow.OperatorHamaliChg + totalRow.OperatorHamaliChg,
                OtherCharges: grandTotalRow.OtherCharges + totalRow.OtherCharges,
                Valuation: grandTotalRow.Valuation + totalRow.Valuation,
                BookingGST: grandTotalRow.BookingGST + totalRow.BookingGST,
                NetAmount: grandTotalRow.NetAmount + totalRow.NetAmount
            }
            detailsData.sort((a, b) => moment(`${a.ReceiptDate} ${a.ReceiptTime}`).valueOf() - moment(`${b.ReceiptDate} ${b.ReceiptTime}`).valueOf());
            detailsData = detailsData.map((val, index) => ({ ...val, sno: index + 1 }))
            newData.push(subHeading, headingRow, ...detailsData, { isTotalRow: true, caption: `Total: Transfer From Branch: ${filterData.fromBranchName}:Payment Type:${val}`, align: 'right', colSpan: 9, ...totalRow })
        })
        newData.push({ isTotalRow: true, caption: `Total: Transfer From Branch: ${filterData.fromBranchName}:Payment Type:${filterData.payment}`, align: 'right', colSpan: 9, ...grandTotalRow })
        return newData
    }
    const printReport = (isSave = false) => {
        setState({ ...state, load: true, generatePDF: true })
        const widthCell = calculateTotalTableWidth(columnSummaryDefs)
        setIsPdfLoading(true);
        jsPDF.API.events.push(['addFonts', callAddFontRobotoBold])
        jsPDF.API.events.push(['addFonts', callAddFontRobotoMedium])
        const doc = new jsPDF({ orientation: columnSummaryDefs.length > 13 ? 'l' : 'p', format: columnSummaryDefs.length > 13 ? calculateDynamicFormatLandscape((widthCell > 1122 ? widthCell : 1122) + 60) : calculateDynamicFormatPortrait((widthCell > 900 ? widthCell : 900) + 60), unit: 'px', compress: true })

        doc.setProperties({
            title: ` Branch Transfer Received Report.pdf`,
            subject: 'Branch Transfer Received Report',
            author: 'Maven Tech Labs Pvt. Ltd.',
            keywords: 'maven tech, Cargo system, Branch Transfer Report',
            creator: 'MTLPL',
        })
        var totalPagesExp = '{total_pages_count_string}'
        var pageSize = doc.internal.pageSize
        var pageHeight = pageSize.height ? pageSize.height : pageSize.getHeight()
        var pageWidth = pageSize.width ? pageSize.width : pageSize.getWidth()
        var pdfFontSize = pageWidth / (columnSummaryDefs.length > 13 ? 1122 : 793);
        const jsPdfHeaderFooter = (data, userData, totalPagesExp) => {
            const doc = data.doc
            // Footer
            var str = 'Page : ' + doc.internal.getNumberOfPages()
            if (typeof doc.putTotalPages === 'function') {
                str = str + ' of ' + totalPagesExp
            }
            doc.setFontSize(pdfFontSize * 14)
            doc.text(str, doc.internal.pageSize.width - data.settings.margin.left + 130, pageHeight - 5, "right")
            doc.setFont('Roboto', 'bold')
            doc.text(`Report By : ${userData.strUserName} [ ${userData.strBranchName} ]`, 30, pageHeight - 5)
            doc.text(`Report Time : ${moment(new Date()).format('DD MMM YYYY, ddd, HH:mm')}`, (doc.internal.pageSize.width / 2) - (doc.getStringUnitWidth(`Report Time : ${moment(new Date()).format('DD MMM YYYY, ddd, HH:mm')}`) * doc.internal.getFontSize() / 2) + 90, pageHeight - 5)
        }

        const HeaderColumns = [
            { header: 'Company', dataKey: 'CompanyName', xlCol: { dataType: 'string' } },
            { header: 'Transfer From Branch', dataKey: 'fromBranchName', xlCol: { dataType: 'string' } },
            { header: 'Received By Branch', dataKey: 'toBranchName', xlCol: { dataType: 'string' } },
        ]
        autoTable(doc, {
            margin: { top: 60, left: 30, right: 30, bottom: 5 },
            alternateRowStyles: {
                fillColor: [255, 255, 255],
            },
            columns: HeaderColumns,
            body: [filterData],
            startY: 160,
            theme: 'grid',
            headStyles: {
                fillColor: [191, 225, 255],
                textColor: [0, 0, 0],
                minCellHeight: 36,
                valign: 'middle',
                cellPadding: 12,
                fontSize: pdfFontSize * 14,
                lineWidth: 0.6,
                font: 'Roboto',
                fontStyle: "normal"
            },
            columnStyles: {
                0: { textColor: [0, 0, 0], fontSize: pdfFontSize * 14, cellPadding: 12, minCellHeight: 36, valign: 'middle', minCellWidth: 225, font: 'Roboto', fontStyle: 'normal', halign: 'left' },
                1: { textColor: [0, 0, 0], fontSize: pdfFontSize * 14, cellPadding: 12, minCellHeight: 36, valign: 'middle', minCellWidth: 225, font: 'Roboto', fontStyle: 'normal', halign: 'left' },
                2: { textColor: [0, 0, 0], fontSize: pdfFontSize * 14, cellPadding: 12, minCellHeight: 36, valign: 'middle', minCellWidth: 225, font: 'Roboto', fontStyle: 'normal', halign: 'left' },
            },
            didDrawPage: function (data) {
                doc.setTextColor(0, 0, 0)
                doc.setFontSize(pdfFontSize * 16).setFont('Roboto', 'bold')
                doc.text(`Transfer Date: ${filterData?.FromDate} To ${filterData?.ToDate}`, data.settings.margin.left, 150)
                doc.text(`Report View: Detailed`, doc.internal.pageSize.width - data.settings.margin.left, 150, "right")
            },
            showHead: "firstPage",
        })
        const HeaderColumns1 = [
            { header: 'Select Vehicle Number', dataKey: 'VehicleNo', xlCol: { dataType: 'string' } },
            { header: 'Payment Type', dataKey: 'payment', xlCol: { dataType: 'string' } },
            { header: 'Report View', dataKey: 'Report', xlCol: { dataType: 'string' } },
        ]
        autoTable(doc, {
            margin: { top: 60, left: 30, right: 30, bottom: 5 },
            alternateRowStyles: {
                fillColor: [255, 255, 255],
            },
            columns: HeaderColumns1,
            body: [filterData],
            startY: doc.lastAutoTable.finalY,
            theme: 'grid',
            headStyles: {
                fillColor: [191, 225, 255],
                textColor: [0, 0, 0],
                minCellHeight: 36,
                valign: 'middle',
                cellPadding: 12,
                fontSize: pdfFontSize * 14,
                lineWidth: 0.6,
                font: 'Roboto',
                fontStyle: "normal"
            },
            columnStyles: {
                0: { textColor: [0, 0, 0], fontSize: pdfFontSize * 14, cellPadding: 12, minCellHeight: 36, valign: 'middle', minCellWidth: 225, font: 'Roboto', fontStyle: 'normal', halign: 'left' },
                1: { textColor: [0, 0, 0], fontSize: pdfFontSize * 14, cellPadding: 12, minCellHeight: 36, valign: 'middle', minCellWidth: 225, font: 'Roboto', fontStyle: 'normal', halign: 'left' },
                2: { textColor: [0, 0, 0], fontSize: pdfFontSize * 14, cellPadding: 12, minCellHeight: 36, valign: 'middle', minCellWidth: 225, font: 'Roboto', fontStyle: 'normal', halign: 'left' },
            },
            showHead: "firstPage",
        })

        let drawCell = function (data) {
            var rows = data.table.body
            if (data.row.section === 'head') {
                if (['number', 'quantity', 'currency'].indexOf(data.column.raw.xlCol.dataType) !== -1) {
                    data.cell.styles.halign = "right";
                } else {
                    data.cell.styles.halign = "left";
                }
            }
            rows.map((val) => {
                if (val.raw.isSubHeadingRow) {
                    if (val.raw.isSubHeadingData.length > 0) {
                        let prevColSpan = 0;
                        val.raw.isSubHeadingData.map((obj, index) => {
                            val.cells[prevColSpan].text = `${obj.caption}${obj.value}`;
                            val.cells[prevColSpan].colSpan = index !== 2 ? Math.floor(columnSummaryDefs.length / 3) : columnSummaryDefs.length - Math.floor(columnSummaryDefs.length / 3) * 2
                            val.cells[prevColSpan].styles.font = 'Roboto'
                            val.cells[prevColSpan].styles.halign = obj.align
                            prevColSpan += index !== 2 ? Math.floor(columnSummaryDefs.length / 3) : columnSummaryDefs.length - Math.floor(columnSummaryDefs.length / 3) * 2
                        })
                    }
                }
                else if (val.raw.isTotalRow) {
                    let prevColSpan = 0;
                    for (let key in val.raw) {
                        if (key == 'caption') {
                            val.cells[prevColSpan].text = val.raw.caption.toString();
                            val.cells[prevColSpan].colSpan = Object.keys(matchFields).length;
                            val.cells[prevColSpan].styles.halign = val.raw.align
                            prevColSpan += Object.keys(matchFields).length;
                        }
                        else {
                            if (key !== 'isTotalRow' && key !== 'colSpan' && key !== 'align') {
                                if (selectedFields.hasOwnProperty(key)) {
                                    val.cells[prevColSpan].text = val.raw[key].toString();
                                    prevColSpan += 1;
                                }
                            }
                        }
                    }
                } else if (val.raw.isNoData) {
                    val.cells[0].text = val.raw.caption.toString();
                    val.cells[0].colSpan = columnSummaryDefs.length;
                    val.cells[0].styles.halign = 'center'
                } else if (val.raw.isPrintHeading) {
                    val.cells[0].text = val.raw.caption;
                    val.cells[0].colSpan = columnSummaryDefs.length;
                    val.cells[0].styles.halign = val.raw.align
                }
            })
        }
        let pdfColumns = columnSummaryDefs.map((col) => {
            return { header: col.exportHead, dataKey: col.field, xlCol: col.xlCol }
        })
        let pdfColumnsData = reportData.map((obj) => {
            if (obj.isRowData) {
                return {
                    ...obj,
                    LRNO: `${UseFormattedLRinReports !== 2?obj.LRNO:obj.FormattedLRNO}\n${obj.ManualLRNo}`,
                    ReceiptDate: `${obj.ReceiptDate}\n${obj.ReceiptTime}`,
                    Sender: `${obj.Sender}\n${obj.SenderMobileNo}`,
                    SenderGSTN: loginCountryId===2?obj.SenderEmailID:`${obj.SenderGSTN}\n${obj.SenderEmailID}`,
                    RecName: `${obj.RecName}\n${obj.RecMobileNo}`,
                    ReceiverGSTN:loginCountryId===2?obj.ReceiverEmailID:`${obj.ReceiverGSTN}\n${obj.ReceiverEmailID}`,
                    Remarks: obj.Remarks
                }
            }
            return obj
        })
        autoTable(doc, {
            margin: { top: 120, left: 30, right: 30, bottom: 40 },
            alternateRowStyles: {
                fillColor: [255, 255, 255],
            },
            columns: pdfColumns,
            tableLineWidth: 0.6,
            body: pdfColumnsData,
            styles: {
                lineWidth: [0, 0.6, 0, 0.6]
            },
            columnStyles: generateDynamicColumnStyles(columnSummaryDefs, pdfFontSize * 12),
            theme: 'grid',
            headStyles: {
                fillColor: [191, 225, 255],
                textColor: [0, 0, 0],
                fontSize: pdfFontSize * 12,
                minCellHeight: 36,
                cellPadding: 6,
                valign: 'top',
                font: 'Roboto',
                fontStyle: "normal"
            },
            didParseCell: (data) => {
                drawCell(data)
            },
            willDrawCell: (data) => {
                if (data.row.raw.isHeaderRow) {
                    doc.setFillColor(191, 225, 255);
                    doc.setTextColor(0, 0, 0);
                    doc.setFontSize(pdfFontSize * 12).setFont("Roboto", 'normal')
                    data.cell.styles.valign = 'middle';
                }
                else if (data.row.raw.isSubHeadingRow) {
                    doc.setFillColor(241, 249, 255);
                    doc.setTextColor(0, 0, 0);
                    doc.setFontSize(pdfFontSize * 12).setFont("Roboto", 'normal')
                    data.cell.styles.valign = 'middle';

                }
                else if (data.row.raw.isTotalRow) {
                    doc.setFillColor(238, 238, 238);
                    doc.setFontSize(pdfFontSize * 12)
                    doc.setTextColor(0, 0, 0);
                    data.cell.styles.valign = 'middle';

                } else if (data.row.raw.isPrintHeading) {
                    doc.setFillColor(191, 225, 255);
                    doc.setTextColor(0, 0, 0);
                    doc.setFontSize(pdfFontSize * 12).setFont("Roboto", 'normal')
                    data.cell.styles.valign = 'middle';

                }
            },
            didDrawPage: function (data) {
                doc.setTextColor(pdfFontSize * 40)
                doc.addImage('/images/logo-66.png', 'JPEG', 30, 50, 50, 50)
                doc.setFontSize(pdfFontSize * 20).setFont("Roboto", 'bold')
                doc.setTextColor(16, 79, 162)
                doc.text('Cargo System | Branch Transfer Received Report', 30 + 60, 80)
                doc.setTextColor(0, 0, 0)
                doc.setFontSize(pdfFontSize * 20).setFont("Roboto", 'bold')
                doc.text(`Company Name :${loginData.strCompanyName}`, doc.internal.pageSize.width - data.settings.margin.left, 80, "right")
                jsPdfHeaderFooter(data, loginData, totalPagesExp)
            },
            showHead: "never",

        })
        doc.setFont('Roboto')
        if (typeof doc.putTotalPages === 'function') {
            doc.putTotalPages(totalPagesExp)
        }
        if (isSave) {
            doc.save(`BranchTransferReceivedReport ${currentDateTime}.pdf`)
        }
        setTimeout(() => {
            setState({ ...state, generatePDF: false, load: true })
            const pdfUrl = doc.output('bloburl')
            document.getElementById('output').data = pdfUrl
            // document.getElementById('output').data = doc.output('datauristring', ' BranchTransferReceivedReport.pdf')
            focusElemnt('backBtn')
        }, 2000)
    }
    const backToScreenView = () => {
        setIsPdfLoading(false)
        const data = document.getElementById('output')
        data.innerHTML = ''
    }
    const BranchTransRecExcelCol = getBranchTransRecExcelHeader(loginCountryId, UseFormattedLRinReports,loginData);
    return (
        <>
            <Box sx={{ ...sx.reportFlex, justifyContent: 'space-between', alignItems: 'center', marginTop: '10px' }}>
                <Box sx={{ display: 'flex', alignItems: 'center', }}>

                    <Typography variant="h5" display="block" sx={{ fontWeight: 600, color: '#444' }}>
                        Report For:Branch Transfer Received Report
                    </Typography>
                    <Box
                        sx={{
                            minHeight: '32px',
                            display: 'flex',
                            padding: '8px 12px',
                            justifycontent: 'center',
                            alignitems: 'center',
                            gap: '6px',
                            marginX: '10px',
                            fontSize: '14px'
                        }}
                        id="dispatchReportManageColumn"
                        tabIndex={0}
                        onClick={() => updateModal(true, mdt.BrnhTransferRecCol)}
                    >
                        <span tabIndex={0} style={{ display: 'flex', margin: '-3px' }}>
                            <AppsIcon />
                        </span>
                        <span tabIndex={0} style={{ fontWeight: '600' }}>
                            MANAGE COLUMNS
                        </span>
                    </Box>
                </Box>
                <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: '10px', alignItems: 'center' }} className="itemButtons">
                    {!isPdfLoading ?
                        <>
                            <Item sx={sx.itemsx} className="disabled-wrapper">
                                {disableExcel ?
                                    <Button variant="outlined" sx={{ width: '100%' }} disabled={true} className="receiveitembtn">
                                        Export to Excel
                                    </Button>
                                    :
                                    <div onKeyDown={(e) => {
                                        navigation3(e, "exportPdf", id.reportmainButton, () => { })
                                    }}
                                    >
                                        <ReactHtmlTableToExcel
                                            id="exportExcelBtn"
                                            className="receiveitemExcelBtn"
                                            table="BranchTransferReceived"
                                            filename={`Branch Transfer Received Report ${currentDateTime}`}
                                            sheet="tablexls"
                                            buttonText="Export to Excel"
                                        />
                                    </div>
                                }
                            </Item>
                            <Item sx={sx.itemsx} className="disabled-wrapper">
                                <Button variant="outlined" id={"exportPdf"} sx={{ width: '100%' }} className="receiveitembtn"
                                    onKeyDown={(e) => {
                                        navigation3(e, "printBtn", disableExcel ? id.reportmainButton : "exportExcelBtn", () => printReport(true))
                                    }}
                                    onClick={() => {
                                        printReport(true)
                                    }}>
                                    Export As PDF
                                </Button>
                            </Item>
                            <Item sx={sx.itemsx} className="disabled-wrapper">
                                <Button variant="outlined" id={'printBtn'} sx={{ width: '100%' }} className="receiveitembtn"
                                    onKeyDown={(e) => {
                                        navigation3(e, id.fromDate, "exportPdf", () => printReport())
                                    }}
                                    onClick={() => {
                                        printReport()
                                    }}>
                                    Print
                                </Button>
                            </Item>
                        </>
                        :
                        <Item sx={sx.itemsx} className="disabled-wrapper">
                            <Button variant="outlined" id={"backBtn"} sx={{ width: '100%' }} className="receiveitembtn"
                                onKeyDown={(e) => {
                                    navigation3(e, id.fromDate, id.reportmainButton, () => {
                                        backToScreenView()
                                        focusElemnt(id.reportmainButton)
                                    })
                                }}
                                onClick={backToScreenView}>
                                Back
                            </Button>
                        </Item>
                    }
                </Box>
            </Box>
            {!isPdfLoading ?

                <Box sx={sx.reportFlex}>
                    <TableContainer component={Paper} className='scroll' sx={{
                        maxHeight: '50vh', marginBottom: "5px",
                    }} >
                        <Table sx={{ minWidth: '1400px' }} stickyHeader size="small" aria-label="a dense table">
                            <TableHead style={{ position: `sticky`, top: `0` }}>
                                <TableRow>
                                    <TableCell style={{
                                        minHeight: "36px",
                                        backgroundColor: tableHeaderColor?.isHeadingColor,
                                        color: '#454646',
                                        fontSize: '12px',
                                        fontWeight: '700',
                                        textAlign: 'left',
                                    }}
                                        colSpan={columnSummaryDefs.length}
                                    >
                                        Branch Transfer Received Report
                                    </TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {reportData.map((row, index) => {
                                    return row.isRowData ?
                                        <TableRow key={`TD-${index}`} sx={{ verticalAlign: 'top' }}>
                                            <TableCell style={{ minHeight: "36px", textAlign: 'right', fontSize: '12px', paddingTop: '12px' }}>{row.sno}</TableCell>
                                            <TableCell style={{ minHeight: "36px", textAlign: 'left', fontSize: '12px', paddingTop: '12px', maxWidth: '150px' }}>
                                                <Tooltip title={row.LRNO} placement="top-start">
                                                    <span style={{ display: 'block', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>{UseFormattedLRinReports !== 2?row.LRNO:row.FormattedLRNO}</span>
                                                </Tooltip>
                                                <span style={{ display: 'block', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>{row.ManualLRNo}</span>
                                            </TableCell>
                                            {
                                                UseFormattedLRinReports === 3 &&
                                                <TableCell style={{ minHeight: "36px", textAlign: 'left', fontSize: '12px', paddingTop: '12px', }}>{row.FormattedLRNO}</TableCell>
                                            }
                                            <TableCell style={{ minHeight: "36px", textAlign: 'left', fontSize: '12px', paddingTop: '12px', }}>{row.ChallanNo}</TableCell>
                                            <TableCell style={{ minHeight: "36px", textAlign: 'left', fontSize: '12px', paddingTop: '12px' }}>
                                                <span style={{ display: 'block', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>{row.ReceiptDate}</span>
                                                <span style={{ display: 'block', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>{row.ReceiptTime}</span>
                                            </TableCell>
                                            {selectedFields.hasOwnProperty('Sender') &&
                                                <TableCell style={{ minHeight: "36px", textAlign: 'left', fontSize: '12px', paddingTop: '12px', maxWidth: '120px' }}>
                                                    <Tooltip title={row.Sender} placement="top-start">
                                                        <span style={{ display: 'block', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>{row.Sender === '' ? '-' : row.Sender}</span>
                                                    </Tooltip>
                                                    <Tooltip title={row.SenderMobileNo} placement="top-start">
                                                        <span style={{ display: 'block', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>{row.SenderMobileNo === '' ? '-' : row.SenderMobileNo}</span>
                                                    </Tooltip>
                                                </TableCell>
                                            }
                                            {selectedFields.hasOwnProperty('SenderGSTN') &&
                                                <TableCell style={{ minHeight: "36px", textAlign: 'left', fontSize: '12px', paddingTop: '12px', maxWidth: '150px' }}>
                                                    <Tooltip title={row.SenderGSTN} placement="top-start">
                                                        <span style={{ display: 'block', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>{row.SenderGSTN === '' ? '-' : row.SenderGSTN}</span>
                                                    </Tooltip>
                                                    <Tooltip title={row.SenderEmailID} placement="top-start">
                                                        <span style={{ display: 'block', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>{row.SenderEmailID === '' ? '-' : row.SenderEmailID}</span>
                                                    </Tooltip>
                                                </TableCell>
                                            }
                                            {selectedFields.hasOwnProperty('RecName') &&

                                                <TableCell style={{ minHeight: "36px", textAlign: 'left', fontSize: '12px', paddingTop: '12px', maxWidth: "100px" }}>
                                                    <Tooltip title={row.RecName} placement="top-start">
                                                        <span style={{ display: 'block', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>{row.RecName === '' ? '-' : row.RecName}</span>
                                                    </Tooltip>
                                                    <Tooltip title={row.RecMobileNo} placement="top-start">
                                                        <span style={{ display: 'block', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>{row.RecMobileNo === '' ? '-' : row.RecMobileNo}</span>
                                                    </Tooltip>
                                                </TableCell>
                                            }
                                            {selectedFields.hasOwnProperty('ReceiverGSTN') &&
                                                <TableCell style={{ minHeight: "36px", textAlign: 'left', fontSize: '12px', paddingTop: '12px', maxWidth: '150px' }}>
                                                    <Tooltip title={row.ReceiverGSTN} placement="top-start">
                                                        <span style={{ display: 'block', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>{row.ReceiverGSTN === '' ? '-' : row.ReceiverGSTN}</span>
                                                    </Tooltip>
                                                    <Tooltip title={row.ReceiverEmailID} placement="top-start">
                                                        <span style={{ display: 'block', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>{row.ReceiverEmailID === '' ? '-' : row.ReceiverEmailID}</span>
                                                    </Tooltip>
                                                </TableCell>
                                            }
                                            {selectedFields.hasOwnProperty('ItemDetails') &&
                                                <TableCell style={{ minHeight: "36px", textAlign: 'left', fontSize: '12px', paddingTop: '12px', }}>{row.ItemDetails}</TableCell>
                                            }
                                            <TableCell style={{ minHeight: "36px", textAlign: 'right', fontSize: '12px', paddingTop: '12px', }}>{row.Units}</TableCell>
                                            <TableCell style={{ minHeight: "36px", textAlign: 'right', fontSize: '12px', paddingTop: '12px', }}>{row.Freight}</TableCell>
                                            {selectedFields.hasOwnProperty('CartageAmount') &&
                                                <TableCell style={{ minHeight: "36px", textAlign: 'right', fontSize: '12px', paddingTop: '12px', }}>{row.CartageAmount}</TableCell>
                                            }
                                            {selectedFields.hasOwnProperty('HamaliCharge') &&
                                                <TableCell style={{ minHeight: "36px", textAlign: 'right', fontSize: '12px', paddingTop: '12px', }}>{row.HamaliCharge}</TableCell>
                                            }
                                            {selectedFields.hasOwnProperty('OperatorHamaliChg') &&
                                                <TableCell style={{ minHeight: "36px", textAlign: 'right', fontSize: '12px', paddingTop: '12px', }}>{row.OperatorHamaliChg}</TableCell>
                                            }
                                            {selectedFields.hasOwnProperty('OtherCharges') &&
                                                <TableCell style={{ minHeight: "36px", textAlign: 'right', fontSize: '12px', paddingTop: '12px', }}>{row.OtherCharges}</TableCell>
                                            }
                                            {selectedFields.hasOwnProperty('Valuation') &&
                                                <TableCell style={{ minHeight: "36px", textAlign: 'right', fontSize: '12px', paddingTop: '12px', }}>{row.Valuation}</TableCell>
                                            }
                                            {selectedFields.hasOwnProperty('BookingGST') &&
                                                <TableCell style={{ minHeight: "36px", textAlign: 'right', fontSize: '12px', paddingTop: '12px', }}>{row.BookingGST}</TableCell>
                                            }
                                            {loginData?.intCompanyID !== RAJESH_TRANSPORT &&
                                                <TableCell style={{ minHeight: "36px", textAlign: 'right', fontSize: '12px', paddingTop: '12px', }}>{row.NetAmount}</TableCell>
                                            }
                                            {loginData?.intCompanyID === RAJESH_TRANSPORT &&
                                                <TableCell style={{ minHeight: "36px", textAlign: 'left', fontSize: '12px', paddingTop: '12px' }}>
                                                    {row.Remarks || ''}
                                                </TableCell>
                                            }
                                        </TableRow>
                                        : row.isTotalRow ?
                                            <TableRow key={`TR-${index}`}>
                                                <TableCell style={{ minHeight: "36px", backgroundColor: tableHeaderColor?.isTotalColor, fontSize: '12px', fontWeight: 'bold', textAlign: 'right', color: '#444' }} colSpan={Object.keys(matchFields).length}>{row.caption}</TableCell>
                                                <TableCell style={{ minHeight: "36px", backgroundColor: tableHeaderColor?.isTotalColor, fontSize: '12px', fontWeight: 'bold', textAlign: 'right', color: '#444' }}>{row.Units}</TableCell>
                                                <TableCell style={{ minHeight: "36px", backgroundColor: tableHeaderColor?.isTotalColor, fontSize: '12px', fontWeight: 'bold', textAlign: 'right', color: '#444' }}>{row.Freight}</TableCell>
                                                {selectedFields.hasOwnProperty('CartageAmount') &&
                                                    <TableCell style={{ minHeight: "36px", backgroundColor: tableHeaderColor?.isTotalColor, fontSize: '12px', fontWeight: 'bold', textAlign: 'right', color: '#444' }}>{row.CartageAmount}</TableCell>
                                                }
                                                {selectedFields.hasOwnProperty('HamaliCharge') &&
                                                    <TableCell style={{ minHeight: "36px", backgroundColor: tableHeaderColor?.isTotalColor, fontSize: '12px', fontWeight: 'bold', textAlign: 'right', color: '#444' }}>{row.HamaliCharge}</TableCell>
                                                }
                                                {selectedFields.hasOwnProperty('OperatorHamaliChg') &&
                                                    <TableCell style={{ minHeight: "36px", backgroundColor: tableHeaderColor?.isTotalColor, fontSize: '12px', fontWeight: 'bold', textAlign: 'right', color: '#444' }}>{row.OperatorHamaliChg}</TableCell>
                                                }
                                                {selectedFields.hasOwnProperty('OtherCharges') &&
                                                    <TableCell style={{ minHeight: "36px", backgroundColor: tableHeaderColor?.isTotalColor, fontSize: '12px', fontWeight: 'bold', textAlign: 'right', color: '#444' }}>{row.OtherCharges}</TableCell>
                                                }
                                                {selectedFields.hasOwnProperty('Valuation') &&
                                                    <TableCell style={{ minHeight: "36px", backgroundColor: tableHeaderColor?.isTotalColor, fontSize: '12px', fontWeight: 'bold', textAlign: 'right', color: '#444' }}>{row.Valuation}</TableCell>
                                                }
                                                {selectedFields.hasOwnProperty('BookingGST') &&
                                                    <TableCell style={{ minHeight: "36px", backgroundColor: tableHeaderColor?.isTotalColor, fontSize: '12px', fontWeight: 'bold', textAlign: 'right', color: '#444' }}>{row.BookingGST}</TableCell>
                                                }
                                                {loginData?.intCompanyID !== RAJESH_TRANSPORT &&
                                                    <TableCell style={{ minHeight: "36px", backgroundColor: tableHeaderColor?.isTotalColor, fontSize: '12px', fontWeight: 'bold', textAlign: 'right', color: '#444' }}>{row.NetAmount}</TableCell>
                                                }
                                                {loginData?.intCompanyID === RAJESH_TRANSPORT &&
                                                    <TableCell style={{ minHeight: "36px", backgroundColor: tableHeaderColor?.isTotalColor }} ></TableCell>
                                                }
                                            </TableRow> : row.isHeaderRow ?
                                                <TableRow key={`TH-${index}`} sx={{ verticalAlign: 'top' }}>
                                                    {columnSummaryDefs.map((col, index) => (
                                                        <TableCell
                                                            key={`THR-${index}`}
                                                            style={{
                                                                ...col.headerSx,
                                                                minHeight: "36px",
                                                                backgroundColor: tableHeaderColor?.isHeadingColor,
                                                                color: '#444',
                                                                fontSize: '12px',
                                                                fontWeight: '600',
                                                                whiteSpace: 'pre-line',
                                                                position: 'sticky',
                                                                top: "60px",
                                                            }}
                                                        >
                                                            {col.header}
                                                        </TableCell>))}
                                                </TableRow>
                                                : row.isSubHeadingRow ?
                                                    <TableRow key={`SHRT-${index}`}>
                                                        {row.isSubHeadingData.map((obj, index) => (
                                                            <TableCell style={{ minHeight: "36px", backgroundColor: '#f1f9ff', position: 'sticky', top: "30px", fontSize: '12px', fontWeight: 'bold', textAlign: obj.align, color: '#444' }} key={`SH-${index}`} colSpan={index !== 2 ? Math.floor(columnSummaryDefs.length / 3) : columnSummaryDefs.length - Math.floor(columnSummaryDefs.length / 3) * 2}>{`${obj.caption}${obj.value}`}</TableCell>
                                                        ))}
                                                    </TableRow> : row.isNoData ?
                                                        <TableRow>
                                                            <TableCell colSpan={row.colSpan} align='center' sx={{ minHeight: "36px", fontSize: '12px', fontWeight: 'bold' }}>{row.caption}</TableCell>
                                                        </TableRow> : null
                                })}
                            </TableBody>
                        </Table>
                    </TableContainer>
                    <BranchReceiveExcel loginCountryId={loginCountryId} UseFormattedLRinReports={UseFormattedLRinReports} selectedFields={selectedFields} columnSummaryDefs={BranchTransRecExcelCol.filter((val) => selectedFields[val.field])} loginData={loginData} filterData={filterData} reportData={reportData} />
                </Box>
                :
                <Box sx={{ ...sx.reportFlex, justifyContent: 'center' }}>
                    {state.generatePDF ? <div className={'generatePDF'}>Generating PDF....</div> : ''}
                    {state.load ? (
                        <object
                            id="output"
                            type="application/pdf"
                            width="100%"
                            height="440"
                            title="MTLPL -Cargo System - LR Wise Detailed Status"
                            aria-label="MTLPL -Cargo System - LR Wise Detailed Status"
                        ></object>
                    ) : (
                        ''
                    )}
                </Box>
            }
        </>
    )
}

export default BranchReceive